export const AppKeys = {
  materials: {
    _English: 'اللغة الإنجليزية',
    _Arabic: 'اللغة العربية',
    _French: 'اللغة الفرنسية',
  },
  _API_PRODUCTION_URL: 'https://emt7any.premiumasp.net/api/v1/',
  _MEDIA_URL_PRODUCTION: 'https://emt7any.premiumasp.net/',
  _API_DEVELOPMENT_URL: 'http://192.168.0.151:8080/api/v1/',
  _MEDIA_URL_DEVELOPMENT: 'http://192.168.0.151:8080/',
  _API_LOCAL_URL: 'https://localhost:44341/api/v1/',
  _API_LOCAL2_URL: 'http://localhost:5076/api/v1/',
  _MEDIA_URL_LOCAL: 'https://localhost:44341/',
  _MEDIA_URL_LOCAL2: 'http://localhost:5076/',
  _FRONTEND_URL: window.location.origin,
};